import { Injectable, EventEmitter } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import {
  SignalRService,
  SignalREventService,
  DataArray,
  Annotation,
  Document,
  ToastrService,
  AuthorizationService,
} from "./../index";

@Injectable()
export class AnnotationService {
  public newAnnotation: EventEmitter<Annotation> =
    new EventEmitter<Annotation>();
  public annotationsChange: EventEmitter<Annotation[]> = new EventEmitter<
    Annotation[]
  >();
  public annotationDocumentsChange: EventEmitter<Document[]> = new EventEmitter<
    Document[]
  >();
  public annotationsCountChange: EventEmitter<any> = new EventEmitter<any>();
  public annotations: DataArray<Annotation> = new DataArray<Annotation>(1);
  public documents: DataArray<Document> = new DataArray<Document>(1);

  constructor(
    private _signalRService: SignalRService,
    private _signalREventService: SignalREventService,
    private _http: HttpClient,
    private _authorizationService: AuthorizationService
  ) {
    this.registerOnServerEvents();

    this.annotations.init();
    this.documents.init();
  }

  public stubNewAnnotation(annot: Annotation): void {
    let document: Document = this.documents.GetByMap(0, annot.DocumentId);
    if (!document) {
      document = $.extend(new Document(), annot.Document);
      document.Annotations = new DataArray<Annotation>();
      document.Annotations.init();
    }
    this.annotations.update(annot, true);
    this.documents.update(document, true);
    this.documents
      .GetByMap(0, annot.DocumentId)
      .Annotations.update(annot, true);
    //this.annotations.update(annot, true);
    this.newAnnotation.emit(annot);
    this.annotationsChange.emit(this.annotations.Data);
    this.annotationDocumentsChange.emit(this.documents.Data);
  }

  private onNewAnnotation(annotation: Annotation): void {
    let document: Document = this.documents.GetByMap(0, annotation.DocumentId);
    if (!document) {
      document = $.extend(new Document(), annotation.Document);
      document.Annotations = new DataArray<Annotation>();
      document.Annotations.init();
    }
    const annot: Annotation = $.extend(new Annotation(), annotation);
    this.annotations.update(annot, true);
    this.documents.update(document, true);
    this.documents
      .GetByMap(0, annot.DocumentId)
      .Annotations.update(annot, true);
    //this.annotations.update(annot, true);
    this.newAnnotation.emit(annot);
    this.annotationsChange.emit(this.annotations.Data);
    this.annotationDocumentsChange.emit(this.documents.Data);
  }

  private onAnnotations(info: any): void {
    for (const annotation of info.Data.Annotations) {
      let document: Document = this.documents.GetByMap(
        0,
        annotation.DocumentId
      );
      if (!document) {
        document = $.extend(new Document(), annotation.Document);
        document.Annotations = new DataArray<Annotation>();
        document.Annotations.init();
      }
      const annot: Annotation = $.extend(new Annotation(), annotation);
      this.annotations.update(annot, true);
      this.documents.update(document, true);
      this.documents
        .GetByMap(0, annot.DocumentId)
        .Annotations.update(annot, true);
    }

    this.annotationsChange.emit(this.annotations.Data);
    this.annotationDocumentsChange.emit(this.documents.Data);
  }

  private onAnnotationCount(info: any): void {
    this.annotationsCountChange.emit(info);
  }

  public getAnnotations() {
    this._signalRService.invoke("GetAnnotations");
  }

  public getAnnotationCount() {
    this._signalRService.invoke("GetAnnotationCount");
  }

  // Error handling
  private handleError(error: any): Observable<never> {
    console.error("Error downloading PDF:", error);
    return throwError("Failed to download PDF. Please try again later.");
  }

  public downloadPDF(id: number): Observable<Blob> {
    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      `Bearer ${this._authorizationService.getAuthorization()}`
    );

    const url = `${window.document.location.origin}/api/manuals/DownloadAnnotation?id=${id}`;
    return this._http
      .get(url, {
        headers: headers,
        responseType: "blob",
      })
      .pipe(catchError(this.handleError));
  }

  private registerOnServerEvents() {
    this._signalREventService.registerAdvanced(
      this,
      "newAnnotation",
      (info: any) => this.onNewAnnotation(info)
    );
    this._signalREventService.registerAdvanced(
      this,
      "annotations",
      (info: any) => this.onAnnotations(info)
    );
    this._signalREventService.registerAdvanced(
      this,
      "beginRecieveAnnotations",
      () => {
        this.annotations.init();
      }
    );
    this._signalREventService.registerAdvanced(
      this,
      "annotationCount",
      (info: any) => this.onAnnotationCount(info)
    );
  }

  public deregisterOnServerEvents(): void {
    this._signalREventService.deregister("GobalService");
  }
}
